<div
  class="flex px-3 py-2"
  [class.pb-5]="isNotched"
  (click)="clickItem.emit()"
>
  <div
    class="grid w-full gap-4 md:gap-5"
    [style.grid-template-columns]="'repeat(' + items.length + ', minmax(0, 1fr))'"
  >
    @for (item of items; track item.value) {
      <div class="flex items-center cursor-pointer">
        @if (item.icon && item.label) {
          <div class="mr-2 flex-shrink-0">
            <app-rounded-icon-button
              [icon]="item.icon"
              [overrideBackgroundColor]="iconBackgroundColor"
              [overrideColor]="iconColor"
              type="light"
            ></app-rounded-icon-button>
          </div>
        }
        <span
          [innerHTML]="item.label | translate"
          class="text-sm kiosk:text-base leading-tight"
          [style.color]="textColor | contentBuilderColor"
        ></span>
      </div>
    }
  </div>
</div>
